import { LinhaVenda } from '@shared/models';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from "@shared/utils/config.service";

import { BaseService } from "./base.service";

import { AcompanharLancamentoSetor } from '@modules/clientes/pages/acompanhar-lancamento-setor/models'

import {
  ParametrosGetHistoricoFaturamento,
  ParametrosGetHistoricoPrevisaoVendas,
  ParametrosGetHistoricoVendas,
  ParametrosGetPrevisaoVendas,
  ParametrosSalvarOuAtualizarPrevisaoVendas,
  RetornoGetHistoricoFaturamento,
  RetornoGetHistoricoPrevisaoVendas,
  RetornoGetHistoricoVendas,
  RetornoGetPeriodoPrevisaoVendas,
  RetornoGetPrevisaoVendas,
  GetTotalClientesSemPrevisaoParametros,
  GetTotalPrevisaoLancamentos
} from './vendas.interface'

// Add the RxJS Observable operators we need in this app.
import "../../rxjs-operators";
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class VendasService extends BaseService {
  baseUrl: string = "";
  mockUrl = "http://localhost:3000"

  constructor(private http: HttpClient, configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  authorizedHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    const authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return headers;
  }

  getComercios() {
    const headers = this.authorizedHeaders();

    return this.http
      .get<any[]>(`${this.baseUrl}/clients/getTipoComercio`, { headers })
      .catch(this.handleError);
  }

  getLinhas() {
    const headers = this.authorizedHeaders();

    return this.http
      .get<LinhaVenda[]>(`${this.baseUrl}/vendas/getLinhas`, { headers })
      .catch(this.handleError);
  }

  getVisaoCidade(parameters) {
    const headers = this.authorizedHeaders();

    return this.http
      .post<any[]>(`${this.baseUrl}/vendas/visaoPorCidade`, parameters, { headers })
      .catch(this.handleError);
  }

  saveRateio(PercLinhaDia, PercLinhaNoite, ValoresCli) {
    const headers = this.authorizedHeaders();

    return this.http
      .post<any>(
        this.baseUrl + "/vendas/realizarRateio ",
        {
          PercLinhaDia,
          PercLinhaNoite,
          ValoresCli
        },
        { headers }
      )
      .catch(this.handleError);
  }

  getMostruarioIdeal(idCli, descricaoLinha) {
    const headers = this.authorizedHeaders();

    return this.http
      .get<any[]>(
        `${this.baseUrl}/vendas/getMostruarioIdeal?IdCli=${idCli}&descricaoLinha=${descricaoLinha}`,
        { headers }
      )
      .catch(this.handleError);
  }

  getSegmentos() {
    const headers = this.authorizedHeaders();

    return this.http
      .get<any[]>(`${this.baseUrl}/vendas/getSegmentos`, { headers })
      .catch(this.handleError);
  }

  getListaClientePrevisaoVenda(parameters) {
    const headers = this.authorizedHeaders();

    return this.http
      .post<any[]>(`${this.baseUrl}/vendas/getListaClientePrevisaoVenda`, parameters, {
        headers
      })
      .catch(this.handleError);
  }

  getListasPrevisaoVenda(linhas: string, idCli: number) {
    const headers = this.authorizedHeaders();

    return this.http
      .post<any[]>(
        `${this.baseUrl}/vendas/getListasPrevisaoVenda?IdCli=${idCli}&linhas=${linhas}`,
        { headers }
      )
      .catch(this.handleError);
  }

  getAcopanharPrevisaoSetor(mesInicio, mesFim) {
    const headers = this.authorizedHeaders();

    return this.http
      .get<AcompanharLancamentoSetor[]>(
        `${this.baseUrl}/vendas/acompanharPrevisaoSetor?mesInicio=${mesInicio}&mesFim=${mesFim}`,
        { headers }
      )
      .catch(this.handleError);
  }

  getPeriodoPrevisaoVendas() {
    const headers = this.authorizedHeaders();

    return this.http
      .get<RetornoGetPeriodoPrevisaoVendas>(
        `${this.baseUrl}/vendas/periodoPrevisao`,
        { headers }
      )
      .catch(this.handleError);
  }

  getPrevisaoVendas(params: ParametrosGetPrevisaoVendas) {
    const headers = this.authorizedHeaders();

    return this.http
      .post<RetornoGetPrevisaoVendas>(`${this.baseUrl}/vendas/ObterPrevisaoVenda`, params, { headers })
      .catch(this.handleError);
  }

  getHistoricoFaturamento(params: ParametrosGetHistoricoFaturamento) {
    const headers = this.authorizedHeaders();

    return this.http
      .get<RetornoGetHistoricoFaturamento>(
        `${this.baseUrl}/vendas/obterFaturamentoCliente`,
        { headers, params: params as any }
      )
      .catch(this.handleError);
  }

  getHistoricoVendas(params: ParametrosGetHistoricoVendas) {
    const headers = this.authorizedHeaders();


    return this.http
      .get<RetornoGetHistoricoVendas>(
        `${this.baseUrl}/vendas/obterVendasCliente`,
        { headers, params: params as any }
      )
      .catch(this.handleError);
  }

  getHistoricoPrevisaoVendas(params: ParametrosGetHistoricoPrevisaoVendas) {
    const headers = this.authorizedHeaders();

    return this.http
      .get<RetornoGetHistoricoPrevisaoVendas>(
        `${this.baseUrl}/vendas/obterHistoricoPrevisaoCliente`,
        { headers, params: params as any }
      )
      .catch(this.handleError);
  }

  salvarOuAtualizarPrevisaoVendas(params: ParametrosSalvarOuAtualizarPrevisaoVendas[]){
    const headers = this.authorizedHeaders();

    return this.http
      .post(`${this.baseUrl}/vendas/salvarOuAtualizarPrevisoes`, params, { headers })
      .catch(this.handleError);
  }

  // -------------------------

  getMeses(term: string = null): any[] {
    let items = getMockMeses();
    if (term) {
      items = items.filter(
        x => x.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1
      );
    }
    return items;
  }

  getTotalPrevisaoLancamentos(params: GetTotalPrevisaoLancamentos) {
    const headers = this.authorizedHeaders();

    return this.http
      .get<number>(
        `${this.baseUrl}/vendas/buscartotallancamento`,
        {
          headers,
          params: params as any
        }
      )
      .catch(this.handleError);
  }

  getTotalClientesSemPrevisao(params: GetTotalClientesSemPrevisaoParametros) {
    const headers = this.authorizedHeaders();

    return this.http
      .get<number>(
        `${this.baseUrl}/vendas/buscartotalsemprevisao`,
        {
          headers,
          params: params as any
        }
      )
      .catch(this.handleError);
  }

  getDaysToClose():Observable<any> {

    console.log("Chamando Back-end")

    const headers = new HttpHeaders();
    headers.append("Content-Type", "text/plain");

    const authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/vendas/getDaysToClose`, { headers })
      .catch(this.handleError);
  }

}

function getMockMeses() {
  return [
    { id: "1", name: "JANEIRO" },
    { id: "2", name: "FEVEREIRO" },
    { id: "3", name: "MARÇO" },
    { id: "4", name: "ABRIL" },
    { id: "5", name: "MAIO" },
    { id: "6", name: "JUNHO" },
    { id: "7", name: "JULHO" },
    { id: "8", name: "AGOSTO" },
    { id: "9", name: "SETEMBRO" },
    { id: "10", name: "OUTUBRO" },
    { id: "11", name: "NOVEMBRO" },
    { id: "12", name: "DEZEMBRO" }
  ];
}
